import type { LinksLookup } from 'src/translators/links-lookup';

// When modifying an existing entry here, you might need to add an NGINX redirect from the old URL to the new one,
// in ireland.template
export const linksLookup: LinksLookup = {
  'book-a-tour': 'book-a-tour',
  'club-facilities': 'club-facilities',
  'club-treatments': 'club-treatments',
  'club-fitness': 'club-fitness',
  'creche': 'creche',
  'exercise-classes': 'exercise-classes',
  'gym': 'gym',
  'sports': 'sports',
  'kids-classes': 'kids-classes',
  'children': 'children',
  'pools': 'pools',
  'spa': 'spa',
  'tennis': 'tennis',
  'enquire-now': 'enquire-now',
  'enquiry-form': 'enquire-now',
  'family-and-kids': 'family-and-kids',
  'golf': 'golf',
  'join-now': 'join-now',
  'manage-your-tour': 'manage-your-tour',
  'membership-trial': 'membership-trial',
  'relax-and-socialise': 'relax-and-socialise',
  'timetable': 'timetable',
  'yoga': 'yoga',
  'blaze': 'blaze',
  'personal-training': 'personal-training',
  'join': 'join',
  // If this link is changed, we should:
  // - Update nginx OJ route handling
  // - Update MSS/Common in the backend
  // - Update the links stored in CC e.g. see DLLABS-10292 (or add an nginx redirect from the old route)
  'join-online': 'join-online',
  // TODO Redesign: Check over these translations
  'membership-type': 'membership-type',
  'members': 'members',
  'personal-details': 'personal-details',
  'your-price': 'your-price',
  'treatments': 'face-body-spa',
  'global-enquire-now': 'enquire-now',
  'memberships': 'memberships',
  'terms-and-conditions': 'terms-and-conditions',
  'policy': 'policy',
  'careers': 'careers',
  'digital-signature': 'digital-signature',
  'young-adult': 'young-adult',
  'family': 'family',
};
